import { ResourceName, ValidAny } from "@/types";
import { DataProvider } from "react-admin";
import { triggerBlobDownload } from "@/utils/formatters/fileUtils";

export const jsonExporter = (records: ValidAny[], downloadFileName: ResourceName) => {
  const blob = new Blob([JSON.stringify(records, null, 2)], { type: "application/json" });
  triggerBlobDownload(blob, `${downloadFileName}-export.json`);
};

export const exportAllJson = (dataProvider: DataProvider, resource: ResourceName) => {
  const result = dataProvider.getList(resource, {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: "id", order: "ASC" },
    filter: {},
  });

  Promise.resolve(result)
    .then((result) => {
      console.log(`Exporting all ${result.data.length} of ${result.total} total records`);

      const blob = new Blob([JSON.stringify(result.data, null, 2)], { type: "application/json" });
      triggerBlobDownload(blob, `${resource}-export-all-${result.data.length}.json`);
    })
    .catch((error) => {
      console.error(`Error exporting all ${resource}:`, error);
    });
};
